import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { toggleNewsletterSubscriberStatus, deleteNewsletterSubscriber } from "@/api/newsletter";

export const useToggleSubscriberStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => toggleNewsletterSubscriberStatus(id),
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ["newsletter", "subscribers"] });
      const next = data?.subscriber?.status;
      toast.success(next === "active" ? "Subscriber reactivated." : "Subscriber unsubscribed.");
    },
    onError: (error) => {
      const message = error.response?.data?.message || error.message || "Failed to update status.";
      toast.error("Toggle failed", { description: message });
    },
  });
};

export const useDeleteSubscriber = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => deleteNewsletterSubscriber(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["newsletter", "subscribers"] });
      toast.success("Subscriber removed.");
    },
    onError: (error) => {
      const message =
        error.response?.data?.message || error.message || "Failed to remove subscriber.";
      toast.error("Remove failed", { description: message });
    },
  });
};
